<p>payment-callback-component works!</p>
